/**
 * Game Panels Store
 * Manages visibility of debug/admin panels in the game view.
 *
 * Panels:
 * - Teacher Controls: For admin/teachers - give chips, show/hide cards, seats, bets
 * - Timing Panel: For admin only - turn timer and pause/resume
 * - Debug Panel: For admin only - game data inspection
 */

import { create } from 'zustand'

interface GamePanelsState {
  // Panel visibility
  showTeacherControls: boolean
  showTimingPanel: boolean
  showDebugPanel: boolean
}

interface GamePanelsActions {
  // Toggle actions
  toggleTeacherControls: () => void
  toggleTimingPanel: () => void
  toggleDebugPanel: () => void

  // Set actions
  setTeacherControls: (show: boolean) => void
  setTimingPanel: (show: boolean) => void
  setDebugPanel: (show: boolean) => void

  // Reset all panels
  resetPanels: () => void
}

const initialState: GamePanelsState = {
  showTeacherControls: false,
  showTimingPanel: false,
  showDebugPanel: false
}

export const useGamePanelsStore = create<GamePanelsState & GamePanelsActions>((set) => ({
  ...initialState,

  // Toggle actions
  toggleTeacherControls: () => set((state) => ({ showTeacherControls: !state.showTeacherControls })),
  toggleTimingPanel: () => set((state) => ({ showTimingPanel: !state.showTimingPanel })),
  toggleDebugPanel: () => set((state) => ({ showDebugPanel: !state.showDebugPanel })),

  // Set actions
  setTeacherControls: (show) => set({ showTeacherControls: show }),
  setTimingPanel: (show) => set({ showTimingPanel: show }),
  setDebugPanel: (show) => set({ showDebugPanel: show }),

  // Reset all panels
  resetPanels: () => set(initialState)
}))
